import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Category, Question} from 'src/app/models';

@Component({
    selector: 'app-question-create',
    templateUrl: './question-create.component.html',
    styleUrls: ['./question-create.component.scss']
})
export class QuestionCreateComponent {
    currentCategory: Category;
    closeDialog = false;
    newQuestion: Question;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.currentCategory = this.data.currentCategory;
        this.newQuestion = new Question(null, this.data.currentCategory, null, null);
    }
}
